import { hexToRgbA, getDarkenColor } from './'

export default (type, colors) => {
  const styles = {
    default: {
      'sets__tools': {
        background: hexToRgbA(colors.secondary, 0.1),
      }
    },
    type1: {
      'sets__c-tabs__tab': {
        fontSize: '16px',
        paddingLeft: 0,
        paddingRight: 0,
        background: 'transparent'
      },
      'sets__c-tabs--pagey': {
        maxWidth: '100%',
        paddingLeft: '30px'
      },
      'search-results__tools': {
        customCSS: `
          .search-results__tools::before {
            display: none;
          }
        `
      },
      'sets__tools': {
        background: getDarkenColor(colors.light, 0.04),
        width: '100%',
        paddingRight: '20px'
      },
      'sets__tools__row': {
        minWidth: '100%',
        customCSS: `
          .c-results-panel {
            display: none;
          }
          @media screen and (min-width: 40em){
            .c-results-panel {
              display: block;
            }
          }
        `
      },
      'sets__listings': {
        marginTop: '30px',
        customCSS: `
          [data-article-style=grid] .c-article__title {
            max-height: auto!important;
            height: auto!important;
          }
        `
      }
    }
  }

  return styles[type]
}



// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/publicSets.js